import { render, staticRenderFns } from "./AddUsersRegionDropdown.vue?vue&type=template&id=31fd7e44&scoped=true"
import script from "./AddUsersRegionDropdown.vue?vue&type=script&lang=js"
export * from "./AddUsersRegionDropdown.vue?vue&type=script&lang=js"
import style0 from "./AddUsersRegionDropdown.vue?vue&type=style&index=0&id=31fd7e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd7e44",
  null
  
)

export default component.exports